import React from "react";
import styled from "styled-components/macro";
import FooterSection from "./FooterSection";
import { MdChevronRight } from "react-icons/md";
import { MenuLink } from "components/AppHeader/Desktop/TopSection";
interface Props {
  data: FooterMenu;
}
export interface FooterMenu {
  title: string;
  links: FooterLink[];
}

interface FooterLink {
  title: string;
  path: string;
}

const MenuSection: React.FC<Props> = ({ data }) => {
  return (
    <FooterSection title={data.title}>
      {data.links.map((link, idx) => {
        return (
          <Menu key={idx}>
            <MdChevronRight color="white" size="1em" />
            <Text key={idx} className="text-sm" title={link.title} to={link.path}>
              {link.title}
            </Text>
          </Menu>
        );
      })}
    </FooterSection>
  );
};

const Menu = styled.div`
  padding-bottom: 5px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const Text = styled(MenuLink)`
  & + & {
    margin-top: 10px;
  }
`;

export default MenuSection;
